// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout_header__3EItT","footer":"Layout_footer__3EMQb"};